import type { Block } from "building-types/blocks/blockTypes";
import type { Table } from "common/data/table";

export function blocksOnLevel(levelId: string | undefined, blocks: Table<Block>): Block[] {
  const a: Block[] = [];
  for (const blockId in blocks) {
    const block = blocks[blockId];
    if (block.levelId === levelId) {
      a.push(block);
    }
  }
  return a;
}
